import request from './Request';
import config from '../config';

const service = {}

service.login = (body) => {
  return request.post(`/${config.adminVersion}/login/`, body, false)
    .then(data => data);
};

service.forgot = (body) => {
    body['client_url'] = config.web_url + '/password-reset/';
  return request.post(`/${config.adminVersion}/managers/forgot_password/`, body, false)
    .then(data => data);
};

service.reset = (body, prk) => {
  body["prk"] = prk;
  return request.post(`/${config.adminVersion}/managers/reset_password/`, body, false)
    .then(data => data);
};

service.create = (body) => {
  return request.post(`/${config.adminVersion}/managers/`, body, false)
    .then(data => data);
};

service.retrieve = (api_key) => {
  return request.protectedGet(`/${config.adminVersion}/managers/${api_key}/`)
    .then(data => data);
};

export default service



/** WEBPACK FOOTER **
 ** ./src/services/admin.js
 **/